const LOGIN = {
  LOADING: 'LOGIN_LOADING',
  SUCCESS: 'LOGIN_SUCCESS',
  FAILED: 'LOGIN_FAILURE',
};

export {LOGIN};
